import type { TFunction } from 'react-i18next';

import { ProFeedback } from 'modules/marketing-pages/marketing-page.types';

/**
 * Construct a review message with the optional review detail.
 * Will return a string representing the review message with the extra detail.
 *
 * Example Output
 *
 * [Review Title]
 *
 * Review messages
 *
 * [Review Detail] Service Price xx JPY, Service Quality (xx), Pro's Personality (xx)
 *
 * @returns {string} a string representing
 */
export function createReviewMessageWithHeaderAndFooter(
  feedback: ProFeedback,
  t: TFunction<'translation'>
): string {
  if (!feedback.message || feedback.message.length === 0) {
    return '';
  }
  const numberFormatter = new Intl.NumberFormat('ja-JP');
  const messageHeader = feedback.title ? `[${feedback.title}]\n` : '';
  let messageFooter = '';
  if (feedback.pricing || feedback.ratingPersonality || feedback.ratingQuality) {
    const sectionTitle = t('users:profile:reviewDetail:sectionTitle');
    let pricingMessage = '';
    if (
      feedback.pricing &&
      !Number.isNaN(feedback.pricing) &&
      Number.isSafeInteger(feedback.pricing)
    ) {
      pricingMessage = t('users:profile:reviewDetail:pricing', {
        pricing: numberFormatter.format(feedback.pricing),
      });
    }
    const qualityMessage = feedback.ratingQuality
      ? t('users:profile:reviewDetail:quality', {
          quality: feedback.ratingQuality,
        })
      : '';
    const personalityMessage = feedback.ratingPersonality
      ? t('users:profile:reviewDetail:personality', {
          personality: feedback.ratingPersonality,
        })
      : '';
    messageFooter = `\n${sectionTitle}${[pricingMessage, qualityMessage, personalityMessage].join(
      ','
    )}`;
  }

  return `${messageHeader}${feedback.message}${messageFooter}`;
}
